module.exports = __webpack_public_path__ + "static/media/23.5f469541.mp3";